import { gql } from '@apollo/client'

export const MY_CASE_EMAILS_QUERY = gql`
  query MyCaseEmails($page: Int, $limit: Int, $read: Boolean, $sortBy: MyCaseEmailSort) {
    myCaseEmails(page: $page, limit: $limit, read: $read, sortBy: $sortBy) {
      collection {
        id
        direction
        status
        fromAddress
        fromName
        toAddresses
        ccAddresses
        subject
        bodyText
        sanitizedBodyHtml
        read
        readAt
        receivedAt
        hasAttachments
        createdAt
        m2Case {
          id
          identifier
          policyholder {
            id
            firstname
            lastname
          }
        }
        processing {
          id
          fileNumber
        }
        attachments {
          url
          filename
          contentType
          signedId
        }
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
`
